const filterOptions = [
  { value: null, label: "Все вместе" },
  { value: "NEW", label: "Не обработанные" },
  { value: "COMPLETED", label: "Обработанные" },
];

export { filterOptions };
